import { useEffect, useState } from "react";

/**
 * Same as useState, but persists the value (as JSON) in sessionStorage under the given key.
 * Falls back to defaultValue if sessionStorage is unavailable or holds an invalid value.
 */
export function useSessionStorageState(key, defaultValue) {
    const [value, setValue] = useState(() => {
        try {
            const stored = sessionStorage.getItem(key);
            return stored !== null ? JSON.parse(stored) : defaultValue;
        } catch {
            return defaultValue;
        }
    });

    useEffect(() => {
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        } catch {
            // Storage unavailable (e.g. private mode) - keep the in-memory value only
        }
    }, [key, value]);

    return [value, setValue];
}
